/**
 * @file 更多列表数据
 * @author FengGuang(fengguang01@baidu.com)
 */
import {ITextCard} from '../../../../components/text-card/TextCard';

const moreListData: ITextCard[] = [
    {
        title: '模型库',
        text: '经过工业场景验证的官方模型，涵盖视觉、NLP、语音和推荐等AI核心技术领域',
        link: '/modelbase',
        target: '_blank',
        tagText: '查看全部',
    },
    {
        title: '开放数据集',
        text: '基于真实样本的超大规模的开放数据集',
        link: 'http://ai.baidu.com/broad',
        target: '_blank',
        tagText: '查看全部',
    }
];

export default moreListData;
